import { render, staticRenderFns } from "./rubric_filter.vue?vue&type=template&id=640c9abc&scoped=true&"
import script from "./rubric_filter.vue?vue&type=script&lang=js&"
export * from "./rubric_filter.vue?vue&type=script&lang=js&"
import style0 from "./rubric_filter.vue?vue&type=style&index=0&id=640c9abc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640c9abc",
  null
  
)

export default component.exports